import { render, staticRenderFns } from "./PeopleToVisit.vue?vue&type=template&id=90cf4646"
import script from "./PeopleToVisit.vue?vue&type=script&lang=js"
export * from "./PeopleToVisit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports